import _ from 'lodash';
import React from 'react';
import { observer, inject } from 'mobx-react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

// import { MusicPlayer } from '@hfm/components';

import Header from './header';
import AppRoutes from './app-routes';
import Footer from './footer';
import { SessionWarningModal } from 'client/shared/components';

@inject('apiStore', 'genreStore', 'userStore', 'artistStore', 'songsStore', 'albumsStore')
@observer
export default class Root
extends React.Component {
	constructor (props) {
		super(props);
		this.getPayloads();
	}

	async getPayloads () {
		const { genreStore, artistStore, songsStore, albumsStore, userStore } = this.props;
		const artist = await artistStore.getArtistProfile({ songsStore, albumsStore, userStore });
		await genreStore.fetchIfEmpty();

		return artist;
	}

	render () {
		const { apiStore, artistStore } = this.props;

		const { userID } = apiStore;
		const artist = artistStore.loggedInArtist;

		if (_.isEmpty(artist) || _.isEmpty(artist.id)) {

			return null;
		}

		return (
			<Router>
				<div className="artist-cms main-container gradient-bg">
					<div className="grid-x">
						<div className="cell auto">
							<div className="grid-x">
								<div className="cell auto">
									<Header userID={ userID } />
								</div>
							</div>
							<div className="grid-x">
								<Switch>
									<Route exact path="/">
										<div className="cell auto account-form-wrapper">
											<AppRoutes artist={artist} userID={ userID } />
										</div>
									</Route>
									<Route>
										<div className="cell auto artist-cms-wrapper">
											<AppRoutes artist={artist} userID={ userID } />
										</div>
									</Route>
								</Switch>

							</div>
						</div>
					</div>

					<div className="grid-x">
						<div className="cell">
							<Footer />
						</div>
					</div>
				</div>

				<ToastContainer
					position="top-right"
					autoClose={ 5000 }
					hideProgressBar={ false }
				/>
				<SessionWarningModal />
			</Router>
		);
	}
}
